import React from "react";
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { tokens } from "../../../../../public/tokens";

const GRID_COLOR = "rgba(0, 0, 0, 0.1)";
const AXIS_TICK = { fill: "#666", fontSize: tokens.typography.fontSize["md-12px"] };

/**
 * Time Spent bar chart on a quiz submission: time per question, green when answered fully correct, red otherwise.
 * @param {object[]} dataAns Submitted answers in question order (attemptedstatus, score as a number or numeric string, questionType)
 * @param {Array<string | number>} scoreArray Maximum score per question as numbers or numeric strings, same order as dataAns
 * @param {Array<string | number>} timeArr Time spent per question, same order as dataAns
 */
export default function QuizBar({ dataAns, scoreArray, timeArr }) {
    const questionBars = dataAns.map((answer, index) => {
        const isFullyCorrect = answer.attemptedstatus && Number(answer.score) === Number(scoreArray[index]) && answer.questionType !== "Long Answer";

        return {
            label: `Question ${index + 1} ${answer.attemptedstatus ? "Attempted" : "Unattempted"}`,
            timeSpent: Number(timeArr[index]),
            color: isFullyCorrect ? "#5cb85c" : "#ef0303",
        };
    });

    return (
        <div style={{ width: "100%", aspectRatio: "10 / 7" }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={questionBars} barCategoryGap="14%">
                    <CartesianGrid stroke={GRID_COLOR} />
                    <XAxis dataKey="label" tick={AXIS_TICK} stroke={GRID_COLOR} />
                    <YAxis width={40} tick={AXIS_TICK} stroke={GRID_COLOR} />
                    <Tooltip />
                    <Bar dataKey="timeSpent" name="# of Question">
                        {questionBars.map((questionBar) => (
                            <Cell key={questionBar.label} fill={questionBar.color} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
